<ion-item
    [disabled]="disabled"
    lines="none"
    *ngIf="ionItemWrap; else unwrapped"
    [ngClass]="{ 'ion-margin-bottom': addBottomMargin }"
    class="hover-bg-none input-wrapped">
    <div class="full-width">
        <ng-content *ngTemplateOutlet="unwrapped"></ng-content>
    </div>
</ion-item>

<ng-template #unwrapped>
    <div [ngClass]="{ 'ion-margin-bottom': !ionItemWrap && addBottomMargin }">
        <ng-content></ng-content>
    </div>
</ng-template>
